<template>
  <div class="DNFMrb" data-ved="2ahUKEwis-cTajZ_uAhWJUt4KHTEND9YQoWEwK3oECB0QDA">
		<div>
			<div class="xJYWs" style="left: 0px;">
				<div>
					過去 7 日間の感染者数
				</div>
			</div>
			<div>
				<v-row justify="center">
					<v-col cols=12 class="pt-0 pb-0">
						<div class="ak7AKb">
							<div class="jvCr1e">
								<div class="pMgxyd F28S1e" style="left: 83.3%;"></div>
								<div class="iWYMkd">
									<div class="D6mXgd">
										<div class="cwiwob" style="height:0px;"></div>
									</div>
								</div>

								<div v-for="(item, index) in chartData" :key="item.id" class="iWYMkd">
									<div class="D6mXgd">
										<div v-if="index!=6" class="cwiwob" v-bind:style="{height: item.bar + 'px'}"></div>
										<div v-else class="cwiwob VKx1id" v-bind:style="{height: item.bar + 'px'}"></div>

										<div v-bind:style="{height: item.text + 'px'}" class="VKx1idTxt">
											{{item.value}}
										</div>
									</div>
								</div>

								<div class="iWYMkd">
									<div class="D6mXgd">
										<div class="cwiwob UmVrSe" style="height:0px;"></div>
									</div>
								</div>
							</div>
							<div class="wiiKJb">
								<div class="a6Yjue"></div>
								<div v-for="item in dateArray" :key="item" class="a6Yjue">
									<div class="nfViIc">
										<div class="s5aD2b"></div>
										<div class="U6uqsd">
											{{item}}
										</div>
									</div>
								</div>
								<div class="a6Yjue"></div>
							</div>
						</div>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";

export default {
  name: 'patientsWeeklyChart',
  filters: {
    momentLastDate(date) {
      moment.locale("ja");
      return moment(date).format('MM/DD（ddd）');
    }
  },
  props: {
    dateRange: { type: [Array], default: null },
    patients: { type: [Array], default: null },
    baseday: { type: [String], default: '' },
  },
  data: () => ({
  }),
  computed: {
	dateArray: function(){
      var array = []
      moment.locale("ja");
      for (var i=1; i < 8; i++){
        array.push(moment(this.baseday).add(i,'d').format('ddd'));
      }
      return (array)
    },
    dataArray: function(){
      var array = this.patients
      return (array)
    },
	todayData: function(){
      return (this.dataArray[6])
    },
    dataSum: function(){
      var sum = 0
      var array = this.dataArray
      for (var i=0; i < array.length; i++) {
        sum += array[i]
      }
      return (sum)
    },
	barsHeigh: function(){
      var max = Math.max(...this.dataArray)
      var array = this.dataArray
      var result = []
      var height = 60
      for (var i=0; i < array.length; i++) {
        result.push(Math.round(array[i]/max*height*10)/10)
      }
      //console.log(result)
      return (result)
    },
	chartData: function(){
       var data = this.dataArray
       var bars = this.barsHeigh
       var result = []
       for (var i=0; i < bars.length; i++) {
         result.push({id: String(i), value: data[i], bar: bars[i], text: (bars[i] + 20.5)})
       }
       return (result)
	}
  },
  created: function () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.pr-0 {
  padding-right: 0px;
}

div {
    display: block;
}

.DNFMrb {
    position: relative;
}

.xJYWs {
    display: inline-block;
    height: 50px;
    padding-top: 10px;
    position: relative;
    -webkit-transition: left 280ms cubic-bezier(.4,0,.2,1),right 280ms cubic-bezier(.4,0,.2,1);
    transition: left 280ms cubic-bezier(.4,0,.2,1),right 280ms cubic-bezier(.4,0,.2,1);
}

.s5aD2b {
	background-color: #70757a;
	height: 5px;
	width: 1px
}

.ak7AKb {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-direction: normal;
    box-direction: normal;
    -webkit-box-orient: vertical;
    box-orient: vertical;
    -webkit-flex-direction: column;
    flex-direction: column;
    height: 110px;
}

.jvCr1e {
    background-image: -webkit-linear-gradient(#70757a 1px,rgba(255,255,255,0) 0);
    background-image: linear-gradient(#70757a 1px,rgba(255,255,255,0) 0);
    -webkit-background-size: 100% 33.333%;
    background-size: 100% 33.333%;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    position: relative;
}

.pMgxyd {
    border-left: 1px dotted #bdc1c6;
    bottom: 4px;
    height: 100%;
    left: 50%;
    position: absolute;
    -webkit-transition: 280ms cubic-bezier(.4,0,.2,1);
    transition: 280ms cubic-bezier(.4,0,.2,1);
    -webkit-transition-property: left,right;
    transition-property: left,right;
    width: 1px;
}

.iWYMkd {
    padding-bottom: 3px;
    -webkit-box-direction: normal;
    box-direction: normal;
    -webkit-box-orient: vertical;
    box-orient: vertical;
    -webkit-flex-direction: column;
    flex-direction: column;
    box-pack: end;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    position: relative;
}

.D6mXgd {
    margin: 0 auto;
    position: relative;
    width: 12px;
}

.cwiwob {
    background-color: #039BE5;
    -webkit-border-radius: 8px;
    border-radius: 8px;
    -webkit-transition: height 280ms cubic-bezier(.4,0,.2,1);
    transition: height 280ms cubic-bezier(.4,0,.2,1);
}

.tzRZWe {
    background-color: #bdc1c6;
}

.VKx1id {
    background-color: #ff002b;
    bottom: 0;
    left: 0;
    //opacity: .7;
    position: absolute;
    right: 0;
}

.VKx1idTxt {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
	color: #fff;
	font-size: 12px;
	text-align: center;
	width: 300%;
	transform: translateX(-35%);
	-webkit-transform: translateX(-35%);
}

.UmVrSe {
    background-color: #303F9F;
}

.wiiKJb {
    border-top: 1px solid #70757a;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    height: 24px;
}

.a6Yjue {
    width: 100%;
}

.nfViIc {
	-webkit-box-align: center;
	box-align: center;
	-webkit-align-items: center;
	align-items: center;
	-webkit-box-direction: normal;
	box-direction: normal;
	-webkit-box-orient: vertical;
	box-orient: vertical;
	-webkit-flex-direction: column;
	flex-direction: column;
	box-pack: end;
	-webkit-box-pack: end;
	-webkit-justify-content: flex-end;
	justify-content: flex-end;
	display: -webkit-box;
	display: -webkit-flex;
	display: flex
}

.U6uqsd {
	color: #fff;
	font-size: 11px;
	text-align: center;
	width: 200%
}

</style>
